import { AlternativeAddressTitleType } from '@epicuro-next/models/basket';

export const altenativeBasketAddressTitleTypesLocales: {
  [key in AlternativeAddressTitleType]: string;
} = {
  [AlternativeAddressTitleType.Mr]: $localize`:CBasket|Drop ship form label Mr title type@@dropShipFormLabelMrTitleType:Mr`,
  [AlternativeAddressTitleType.Ms]: $localize`:CBasket|Drop ship form label Ms title type@@dropShipFormLabelMsTitleType:Ms`,
  [AlternativeAddressTitleType.Company]: $localize`:CBasket|Drop ship form label Company title type@@dropShipFormLabelCompanyTitleType:Company`,
  [AlternativeAddressTitleType.MrAndMrs]: $localize`:CBasket|Drop ship form label Mr and Mrs title type@@dropShipFormLabelMrAndMrsTitleType:Mr and Mrs`,
};
